
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Skeleton } from "../../Components/Skeleton.js";
import { empty, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Table } from "../../Widgets/Table/Table.js";
import { singleton as singleton_1, toArray as toArray_1, ofArray, empty as empty_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapLocationId } from "../../Shared/Helper.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { Button } from "../../Components/Button.js";

export function LocationOverviewTable(props) {
    let elems;
    const t = useTranslation()[0];
    const matchValue = props.State.Locations;
    const matchValue_1 = props.State.AccountSettings;
    let matchResult, accountSettings, locations;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 1;
            accountSettings = matchValue_1.fields[0];
            locations = matchValue.fields[0];
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "table",
            });
        default: {
            const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("Description", "", t("general.description"), (dto_1) => (new CellContent(0, [dto_1.Description])), "text", "text")), delay(() => (accountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_2) => (new CellContent(0, [defaultArg(dto_2.BusinessUnitName, "")])), "select", "text")) : empty())))))));
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(Table, {
                ColumnDefinitions: columnDefinitions,
                Controls: empty_1(),
                Options: {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["name", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    OnRowClick: new OnTableRowClick$1(1, [(dto_3) => RouterModule_encodeParts(ofArray(["locations", unwrapLocationId(dto_3.Id)]), 1)]),
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                },
                TableKey: "not-defined-table",
                TableRows: toArray_1(locations),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
    }
}

export function LocationOverview() {
    let elems_2, elems_1, elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-5", "items-center"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["align-bottom"])], (elems = [createElement(TabsMenu, {
        Tabs: ofArray([{
            IsSelected: false,
            Label: t("navbar.storages"),
            OnClick: () => {
                RouterModule_nav(ofArray(["storages"]), 1, 1);
            },
            TestId: "",
        }, {
            IsSelected: true,
            Label: t("navbar.locations"),
            OnClick: () => {
                RouterModule_nav(ofArray(["locations"]), 1, 1);
            },
            TestId: "",
        }]),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Button, {
        ComponentState: "enabled",
        Label: t("location.create_new_location"),
        OnClick: () => {
            RouterModule_nav(ofArray(["locations", "new"]), 1, 1);
        },
        TestId: "new-location-button",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(LocationOverviewTable, {
        State: patternInput[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

